import { useSelector } from 'react-redux'

import { translate } from '@/utils/translations'

import BeginCheckoutButton from './BeginCheckoutButton'
import CartHeading from './CartHeading'

const MobileCartHeader = () => {
  const subTotal = useSelector(state => state.cart.formattedSubTotal)
  const itemCount = useSelector(state => state.cart.itemsTotalCount)
  const itemCountText = (itemCount === 0 || itemCount > 1)
    ? translate('carts.items')
    : translate('carts.item')

  return (
    <>
      <div className='u-align--center'>
        <CartHeading />
        <p>
          {translate('carts.subtotal')} {`${subTotal}
          | ${itemCount}`} {itemCountText}
        </p>
      </div>
      <BeginCheckoutButton />
    </>
  )
}

export default MobileCartHeader
